import { Link } from "react-router-dom";
import logo from "@/assets/Weautomate logo-01.png";

const Col = ({ title, items }) => (
  <div>
    <div className="text-xs uppercase tracking-widest text-white/40 mb-4">{title}</div>
    <ul className="space-y-2.5">
      {items.map((i) => (
        <li key={i.label}>
          <Link to={i.to} className="text-sm text-white/70 hover:text-white">{i.label}</Link>
        </li>
      ))}
    </ul>
  </div>
);

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 mt-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 pt-20 pb-12">
        <div className="grid lg:grid-cols-5 gap-12">
          <div className="lg:col-span-2 max-w-md">
            <Link to="/" className="flex items-center mb-5">
              <img src={logo} alt="WeAutomate" className="h-10 w-auto" />
            </Link>
            <p className="text-sm text-white/60 leading-relaxed">
              From your idea to a shippable product — engineered in India.
              An umbrella for OEM/ODM, Home & Industrial Automation, SaaS,
              a marketplace, and an opportunities ecosystem.
            </p>
            <div className="mt-6 text-xs text-white/40 font-mono">
              hello@weautomate.tech · India
            </div>
          </div>
          <Col title="Build" items={[
            { label: "OEM / ODM", to: "/oem-odm" },
            { label: "Home Automation", to: "/home-automation" },
            { label: "Industrial Automation", to: "/industrial-automation" },
            { label: "Marketplace", to: "/marketplace" },
          ]} />
          <Col title="Grow with us" items={[
            { label: "Franchise", to: "/opportunities/franchise" },
            { label: "Affiliate", to: "/opportunities/affiliate" },
            { label: "Influencer", to: "/opportunities/influencer" },
            { label: "Jobs", to: "/opportunities/job" },
            { label: "Internship", to: "/opportunities/internship" },
          ]} />
          <Col title="Company" items={[
            { label: "Founders", to: "/founders" },
            { label: "Investors", to: "/investors" },
            { label: "Blog", to: "/blog" },
            { label: "About", to: "/about" },
            { label: "Contact", to: "/contact" },
          ]} />
        </div>
        {/* pr-20 on md+ keeps the right-aligned credit clear of the floating
            chatbot FAB (fixed bottom-6 right-6, ~56px wide) when scrolled to
            the bottom around the md breakpoint. */}
        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40 md:pr-20">
          <div>© {new Date().getFullYear()} WeAutomate Technologies. All rights reserved.</div>
          <div>Made with intent in India.</div>
        </div>
      </div>
    </footer>
  );
}
